import GeneralDetail from "./general/general_details.store";
import Image from "./image/teacher_image.store";

export default {
  modules: { GeneralDetail, Image },
};
